export default "__VITE_ASSET__BH8N9gKD__"